import React from 'react';
import { Navbar, Container, Form, InputGroup, Badge } from 'react-bootstrap';
import { FaSearch, FaBell, FaUserCircle } from 'react-icons/fa';

function TopBar() {
  return (
    <Navbar bg="white" className="border-bottom py-3 shadow-sm">
      <Container fluid className="px-4">
        <div className="d-flex align-items-center flex-grow-1">
          <h4 className="mb-0 fw-bold">Dashboard</h4>
          <p className="mb-0 text-muted ms-3 d-none d-md-block">Monitor key metrics and manage your operations.</p>
        </div>

        <div className="d-flex align-items-center gap-3">
          <Form className="d-none d-lg-block">
            <InputGroup>
              <InputGroup.Text className="bg-light border-end-0">
                <FaSearch className="text-muted" />
              </InputGroup.Text>
              <Form.Control
                type="search"
                placeholder="Search"
                className="border-start-0 bg-light"
                style={{ width: '250px' }}
              />
            </InputGroup>
          </Form>

          <div className="position-relative">
            <FaBell size={20} className="text-muted cursor-pointer" />
            <Badge
              bg="danger"
              pill
              className="position-absolute top-0 start-100 translate-middle"
              style={{ fontSize: '0.65rem' }}
            >
              3
            </Badge>
          </div>

          <FaUserCircle size={32} className="text-muted cursor-pointer" />
        </div>
      </Container>
    </Navbar>
  );
}

export default TopBar;
